import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type { IPersonalSettingsCarePathServiceProviderSettingFormSectionProps } from './PersonalSettingsCarePathServiceProviderSetting';
import { ServiceCode } from '../../../../../common/enums/serviceCode';
import { ServiceType } from '../../../../../common/enums/serviceType';
import { translateKey } from '../../../../translate';
import { InputTriState } from '../../../elements/common';

export function ExaminationAndGradingSettings(props: IPersonalSettingsCarePathServiceProviderSettingFormSectionProps) {
    const isAnalystTrueAndServiceTCOH = props.isAnalyst && props.service.code === ServiceCode.TCOH;

    if (
        props.service.serviceType !== ServiceType.examination ||
        (props.mode === 'edit' && isAnalystTrueAndServiceTCOH)
    ) {
        return null;
    }

    return (
        <FormSection title={translateKey('addCarePathSettingsHeaders.examinationAndGrading')}>
            <FormGroup label={translateKey('addCarePathSettingsLabelsServiceProvider.isBiometrician')}>
                {props.mode === 'read' ? (
                    <FormParagraph>
                        {props.isBiometrician ? translateKey('common.yes') : translateKey('common.no')}
                    </FormParagraph>
                ) : (
                    <InputTriState
                        fieldKey="isBiometrician"
                        notNullable
                    />
                )}
            </FormGroup>

            <FormGroup label={translateKey('addCarePathSettingsLabelsServiceProvider.isGrader')}>
                {props.mode === 'read' ? (
                    <FormParagraph>
                        {props.isGrader ? translateKey('common.yes') : translateKey('common.no')}
                    </FormParagraph>
                ) : (
                    <InputTriState
                        fieldKey="isGrader"
                        notNullable
                    />
                )}
            </FormGroup>

            {props.isBiometrician && (
                <>
                    <FormGroup label={translateKey('addCarePathSettingsLabelsServiceProvider.isRequestCreator')}>
                        {props.mode === 'read' ? (
                            <FormParagraph>
                                {props.isRequestCreator ? translateKey('common.yes') : translateKey('common.no')}
                            </FormParagraph>
                        ) : (
                            <InputTriState
                                fieldKey="isRequestCreator"
                                notNullable
                            />
                        )}
                    </FormGroup>

                    <FormGroup label={translateKey('addCarePathSettingsLabelsServiceProvider.isGraderSelector')}>
                        {props.mode === 'read' ? (
                            <FormParagraph>
                                {props.isGraderSelector ? translateKey('common.yes') : translateKey('common.no')}
                            </FormParagraph>
                        ) : (
                            <InputTriState
                                fieldKey="isGraderSelector"
                                notNullable
                            />
                        )}
                    </FormGroup>
                </>
            )}
        </FormSection>
    );
}
